// ============================================================
// cf-permission.js — Permission-based UI element guard
// ============================================================
// Companion to [PagePermission(...)] attribute on the server side.
//
// Page-level guarding is handled in cf-auth.js (window.PAGE_PERMISSION
// + redirect to /access-denied). This module hides UI sub-elements
// inside an authorized page based on more granular permissions
// (e.g. Add button requires .create, Edit button requires .edit).
//
// Usage in markup:
//   <button data-cf-permission="app.setting.authentication.users.create">
//     Add User
//   </button>
//
// CF.permission.applyGuards(rootEl) walks rootEl and hides any
// element with a [data-cf-permission] code that the current
// CF.user does not have. Called automatically once on page load
// from cf-auth.js _applyMeData() after CF.user is populated.
//
// For dynamically-rendered elements (e.g. injected after AJAX),
// call CF.permission.applyGuards(container) yourself.
//
// DataTable primaryAction / actions / row menu use a separate
// permission filter inside cf-datatable.js — they consume
// `permission: '...'` properties rather than data attributes.
// ============================================================

window.CF = window.CF || {};

CF.permission = (function () {
    'use strict';

    function _has(code) {
        if (!code) return true;
        return CF.user && CF.user.hasPermission && CF.user.hasPermission(code);
    }

    /**
     * Toggle visibility of any element under `root` whose
     * [data-cf-permission] / [data-cf-permission-any] code does not
     * match the current user's permissions.
     *
     * Idempotent: clears inline display when permission matches so the
     * element falls back to its CSS-defined display value, sets
     * display:none otherwise. Safe to call multiple times (e.g. once
     * synchronously after toolbar render, then again from cf:user-loaded
     * event when user is populated asynchronously after a cache miss).
     *
     * Comma-separated codes:
     *   data-cf-permission        � user must hold ALL listed codes (AND).
     *   data-cf-permission-any    � user must hold AT LEAST ONE (OR).
     */
    function applyGuards(root) {
        var ctx = root || document;

        var allEls = ctx.querySelectorAll('[data-cf-permission]');
        for (var i = 0; i < allEls.length; i++) {
            var codes = (allEls[i].getAttribute('data-cf-permission') || '')
                .split(',').map(function (s) { return s.trim(); }).filter(Boolean);
            var ok = codes.every(_has);
            allEls[i].style.display = ok ? '' : 'none';
        }

        var anyEls = ctx.querySelectorAll('[data-cf-permission-any]');
        for (var j = 0; j < anyEls.length; j++) {
            var anyCodes = (anyEls[j].getAttribute('data-cf-permission-any') || '')
                .split(',').map(function (s) { return s.trim(); }).filter(Boolean);
            var anyOk = anyCodes.length === 0 || anyCodes.some(_has);
            anyEls[j].style.display = anyOk ? '' : 'none';
        }
    }

    /**
     * Convenience: returns true if CF.user has the given permission code.
     * Mirrors CF.user.hasPermission but tolerates CF.user not yet loaded
     * (returns false instead of throwing).
     */
    function has(code) {
        return _has(code);
    }

    return {
        applyGuards: applyGuards,
        has:         has
    };
})();
